import React from "react";
import { FaWhatsapp } from "react-icons/fa"; // Import FontAwesome icon

const WhatsAppButton = () => {
  return (
    <div style={styles.container}>
      <a
        href="https://wa.me/+923291396691" // Replace with your WhatsApp number
        target="_blank"
        rel="noopener noreferrer"
        style={styles.link}
      >
        <div style={styles.iconContainer}>
          <FaWhatsapp style={styles.icon} />
        </div>
      </a>
    </div>
  );
};

const styles = {
  container: {
    position: "fixed",
    bottom: "20px", // Adjust as per your requirement
    right: "20px",
    zIndex: 1000, // Ensures it stays on top
  },
  link: {
    textDecoration: "none",
  },
  iconContainer: {
    width: "60px", // Diameter of the circle
    height: "60px",
    backgroundColor: "white", // White background for the circle
    borderRadius: "50%", // Makes it circular
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // Optional shadow for better design
    transition: "transform 0.3s ease",
  },
  iconContainerHover: {
    transform: "scale(1.5)", // Optional scaling effect on hover
  },
  icon: {
    fontSize: "2.5rem", // Adjust size of the icon
    color: "#25D366", // WhatsApp green color
    cursor: "pointer",
  },
};

export default WhatsAppButton;
